
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Resolver } from 'react-hook-form';
import { ICreateOrEditFAQ } from '@Types/FAQ';

const schema = yup.object().shape({
  question: yup.string().required('Question is required'),
  answer: yup.string().required('Answer is required'),
  order: yup
    .number()
    .typeError('Order must be a number')
    .integer('Order must be an integer')
    .min(0, 'Order must be at least 0')
    .required('Order is required'),
});

// Cast to the proper resolver type
export default yupResolver(schema) as unknown as Resolver<ICreateOrEditFAQ, any>;